export const scrollToTops = () => {
// scroll to top
  const scrollTop = document.getElementById('js-top')
  const scrollTopSocial = document.getElementById('js-top-second')
  window.onscroll = () => {
    if (window.innerWidth > 1200) {
      if ((window.scrollY > 150)) {
        scrollTopSocial.style.visibility = 'visible';
        scrollTopSocial.style.opacity = 1;
      } else {
        scrollTopSocial.style.visibility = 'hidden';
        scrollTopSocial.style.opacity = 0;
      }
    }
    if ((window.scrollY > 150)) {
      scrollTop.style.visibility = 'visible';
      scrollTop.style.opacity = 1;
    } else {
      scrollTop.style.visibility = 'hidden';
      scrollTop.style.opacity = 0;
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/components/js-component/scroll-to-top.js